import React, { useState, useEffect } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "react-bootstrap";
import { getAllocatedEmployeesDetails } from "../actions";
import Maintenance from "../../Maintenance";

/*** 
@purpose : Functional Component
@Parameter : {props}
**/
function AllocatedEmployees(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [details, setDetails] = useState([]);
  const [data, setData] = useState({});
  const [limit, setLimit] = useState(40);
  const [loading, setLoading] = useState(true);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [orgId, setOrgId] = useState();
  const [total, setTotal] = useState(0);

  const [bun, setBUN] = useState("asc");
  const [dn, setDN] = useState("asc");
  const [bn, setBN] = useState("asc");
  const [son, setSON] = useState("asc");
  const [snk, setSNK] = useState("asc");
  const [mnk, setMNK] = useState("asc");
  const [jrn, setJRN] = useState("asc");
  const [manl, setMANL] = useState("asc");
  const [dcf, setDCF] = useState("asc");

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.organizationCustomerDetails")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchData() {
      setOrgId(props.id);
      let body = {
        id: props.id,
        limit: 0,
        totalRecords: 0,
      };
      try {
        const res = await getAllocatedEmployeesDetails(body);
        setLoading(false);
        if (res.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          setDetails(res && res.data.allocatedEmp);
          setTotal(
            res &&
              res.data.allocatedEmp &&
              res.data.allocatedEmp[0] &&
              res.data.allocatedEmp[0].total
          );
        }
      } catch (error) {
        console.error("Error fetching allocated employees:", error);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Lazyload function
  @Parameter : {}
  **/
  // const handleContainerOnBottom = async () => {
  //   setLazyLoading(true);

  //   let body = {
  //     id: orgId,
  //     limit: details.length,
  //     totalRecords: total,
  //   };
  //   setLazyLoading(false);
  //   if (details.length <= total && total >= 30) {
  //     await getAllocatedEmployeesDetails(body).then((response) => {
  //       let list = [];
  //       list = details.concat(response.data.allocatedEmp);
  //       setDetails(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    let body = {
      id: orgId,
      limit: details.length,
      totalRecords: total,
    };
    if (details.length < total) {
      try {
        setLazyLoading(true);
        const response = await getAllocatedEmployeesDetails(body);
        let list = details.concat(response.data.allocatedEmp);
        setDetails(list);
        setLimit(limit + 10);
      } catch (error) {
        console.error("Error loading more records:", error);
      } finally {
        setLazyLoading(false);
      }
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);
  /*** 
  @purpose : Handle sorting
@Parameter : {}
**/
  const handleSortingData = (obj) => {
    obj.column === "buName" && setBUN(obj.sortOrder);
    obj.column === "divisionName" && setDN(obj.sortOrder);
    obj.column === "branchName" && setBN(obj.sortOrder);
    obj.column === "salesofficeName" && setSON(obj.sortOrder);
    obj.column === "salesmanagerNameKanji" && setSNK(obj.sortOrder);
    obj.column === "mrNameKanji" && setMNK(obj.sortOrder);
    obj.column === "JobRoleName" && setJRN(obj.sortOrder);
    obj.column === "market_authourization_name_local" && setMANL(obj.sortOrder);
    obj.column === "double_count_flag" && setDCF(obj.sortOrder);
    let list = compareBySortedData(obj);
    setDetails(list);
  };

  /*** 
@purpose : Compare sorted data
@Parameter : {}
**/
  const compareBySortedData = (obj) => {
    const sorted = details.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  return (
    <>
      {loading ? (
        <Spinner animation="border" />
      ) : !maintenance ? (
        <>
          <div className="org-main">
            <div className="org-wrapper1">
              <h4 className="primary-title">
                {lang("OrganizationMenu.allocatedEmployees")}
              </h4>
              {details && details.length > 0 && (
                <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {details && details.length} / {total}
                </p>
              )}
              {details && details.length > 0 && (
                <>
                  <div
                    // ref={containerRef}
                    // onBottom={
                    //   handleContainerOnBottom
                    // }
                    className="table-responsive mb-0 max-height"
                  >
                    <table className="table" aria-describedby="table">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "buName",
                                sortOrder: bun === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              BU <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "divisionName",
                                sortOrder: dn === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("territoryDefinitionMaintenance.division")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "branchName",
                                sortOrder: bn === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("territoryDefinitionMaintenance.branch")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "salesofficeName",
                                sortOrder: son === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang(
                                "territoryDefinitionMaintenance.salesOffice"
                              )}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "salesmanagerNameKanji",
                                sortOrder: snk === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.manager")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "mrNameKanji",
                                sortOrder: mnk === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("OrganizationMenu.allocatedMR")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "JobRoleName",
                                sortOrder: jrn === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.role")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "market_authourization_name_local",
                                sortOrder: manl === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.product")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "double_count_flag",
                                sortOrder: dcf === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.doubleCount")}
                              <em class="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {details &&
                          details.map((org,index) => {
                            return (
                              org && (
                                <tr key={index}>
                                  <td>{org && org.buName ? org.buName : ""}</td>
                                  <td>
                                    {org && org.divisionName
                                      ? org.divisionName
                                      : ""}
                                  </td>
                                  <td>
                                    {org && org.branchName
                                      ? org.branchName
                                      : ""}
                                  </td>
                                  <td>
                                    {org && org.salesofficeName
                                      ? org.salesofficeName
                                      : ""}
                                  </td>
                                  <td>
                                    <div>
                                      <div>
                                        {org && org.manager_wwid
                                          ? org.manager_wwid
                                          : ""}{" "}
                                      </div>
                                      <div>
                                        {" "}
                                        {org && org.salesmanagerNameKanji
                                          ? org.salesmanagerNameKanji
                                          : ""}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div>
                                        {" "}
                                        {org && org.allocatedmr_wwid
                                          ? org.allocatedmr_wwid
                                          : ""}{" "}
                                      </div>
                                      <div>
                                        {" "}
                                        {org && org.mrNameKanji
                                          ? org.mrNameKanji
                                          : ""}{" "}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    {org && org.JobRoleName
                                      ? org.JobRoleName
                                      : ""}
                                  </td>
                                  <td>
                                    {org && org.market_authourization_name_local
                                      ? org.market_authourization_name_local
                                      : ""}
                                  </td>
                                  <td>
                                    {org && org.double_count_flag
                                      ? org.double_count_flag
                                      : ""}
                                  </td>
                                </tr>
                              )
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {details.length < total && (
                    <div className="steps-action1 mt-4">
                      {lazyLoading && <Spinner animation="border" />}
                      <button
                        className="btn btn-primary"
                        onClick={loadRecords}
                        disabled={lazyLoading}
                      >
                        {lang("Buttons.loadMore")}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <Modal
            size="md"
            className="withdraw-modal"
            show={customerNotFound}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" />
                {lang("errorMessages.CUSTOMER_NOT_FOUND")}
              </div>
              <p className="mb-3">
                {lang("errorMessages.SEARCH_REQUESTS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/organizationCustomer");
                  }}
                >
                  {lang("Menu.organizationCustomer")}
                </a>
              </p>
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <Maintenance />
      )}
    </>
  );
}

export default AllocatedEmployees;
